import { DashboardStat, ITransaction } from "types/dashboard.service";
import { handleGetRequest } from "./http.service";
import { PaginationParams } from "types/general.interface";
import { PaginationDataRes } from "types/http.type";

export const getRegistrationStat = async (
  startDate: string,
  endDate: string
) => {
  return await handleGetRequest<{ labels: string[]; plots: number[] }>(
    `/admins/registration-stats?fromDate=${startDate}&toDate=${endDate}`
  );
};

export const getDashboardStats = async () => {
  return await handleGetRequest<DashboardStat>(`/admins/all-stats`);
};

export const getTransactions = async (query: PaginationParams) => {
  return await handleGetRequest<PaginationDataRes<ITransaction[]>>(
    `/admins/transactions?page=${query.page}&limit=${query.limit}`
  );
};
